import React from "react";
import '../style/style.scss';
import '../style/style.css';
import '@coreui/coreui/dist/css/coreui.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Routes ,Route,Link} from 'react-router-dom';
import CheckHomepage from "./CheckHomepage";
import Login from "./Login";
import PublicRoute from "./PublicRoute";
import PrivateRoute from "./PrivateRoute";
import ClientDetail from "./ClientDetail";
import Copertinacliente from "./CopertinaCliente";
import CheckList from "./CheckList";
import AppContent from "./AppContent"
import Homepage from "./Homepage";
import Clienti from "./Clienti";
import DettaglioLavoratore from "./DettaglioLavoratore";
import Medici from "./Medici";
import DettaglioMedici from "./DettaglioMedici";
import VisiteMediche from "./VIsiteMediche";
import Allegati3B from "./Allegati3B";
import Idoneita from "./Idoneita";

export default class App extends React.Component {

//VEDIAMO SE VA MEGLIO
render() {
    return (
      <div> 
      
      <BrowserRouter>
      <Routes>
    
        <Route path="/login" element={<Login />} />
        
         <Route path="/" element={ <PrivateRoute> <AppContent /></PrivateRoute> } >
         <Route path="/" element={<Homepage/>}/>
             <Route path="checkHomepage" element={<CheckHomepage/>}/>
             <Route path="/dettaglioCliente" element={ <PrivateRoute> <ClientDetail /> </PrivateRoute> } /> 
             <Route path="/checkList" element={ <PrivateRoute> <CheckList /> </PrivateRoute> } /> 
             <Route path="/copertinaCliente" element={ <PrivateRoute> <Copertinacliente /> </PrivateRoute> } />
             <Route path="/clienti" element={ <PrivateRoute> <Clienti /> </PrivateRoute> } />
             <Route path="/dettaglioLavoratore" element={ <PrivateRoute> <DettaglioLavoratore /> </PrivateRoute> } />
             <Route path="/medici" element={ <PrivateRoute> <Medici /> </PrivateRoute> } />    
             <Route path="/dettaglioMedico" element={ <PrivateRoute> <DettaglioMedici /> </PrivateRoute> } />
             <Route path="/visiteMediche" element={ <PrivateRoute> <VisiteMediche /> </PrivateRoute> } />    
             <Route path="/Allegato3B" element={ <PrivateRoute> <Allegati3B /> </PrivateRoute> } /> 
        </Route>
        <Route path="/Idoneita" element={ <PrivateRoute> <Idoneita /> </PrivateRoute> } /> 
        <Route path="*" element={<NotFoundPage />} />




      </Routes>
    </BrowserRouter>
    </div>
  
    );
  }
}

/*


*/
const NotFoundPage = () => {

  return (
    <div >
      <center>
      <h1 style={{ color: "red", fontSize: 100 }}>404</h1>
      <h3>PAGINA NON TROVATA</h3>
      <p>
        <Link to="/">HOMEPAGE</Link>
      </p>
      </center>
    </div>
  );
};
    